<!-- <signature-pad
  [options]="options"
  (onBeginEvent)="drawBegin()"
  (onEndEvent)="drawComplete()"
></signature-pad> -->
<canvas #canvas></canvas>
